import { AuthContextProps } from "../components/auth-context";
import { getData, postData } from "./core";
import RegisterTicket from "../types/register-ticket";

export default class RegisterTicketApi {
  static uri = "a/internet/Ticket";
  context: AuthContextProps;
  constructor(context: AuthContextProps) {
    this.context = context;
  }

  get(fileId: number, page: number, rows: number) {
    return getData({
      uri: RegisterTicketApi.uri,
      params: `?fileId=${fileId}&page=${page}&rows=${rows}`,
      context: this.context,
    });
  }

  post(data: RegisterTicket) {
    return postData({
      uri: RegisterTicketApi.uri,
      context: this.context,
      data,
    });
  }
}
